import { CodeProvider } from './../../providers/code/code';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';

import { UserProvider } from '../../providers/user/user';
import { globalDefines } from '../../app/app.constants';

@IonicPage()
@Component({
  selector: 'page-users',
  templateUrl: 'users.html',
})
export class UsersPage {

  users;
  search;

  constructor(
    public alertCtrl: AlertController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public userProvider: UserProvider,
    public codeProvider: CodeProvider,
  ) {
    //this.users = userProvider.getUserNames();
    this.users = userProvider.getUsers();
  }

  addUser() {
    this.navCtrl.push('UserInfoPage', { mode: 'add' });
  }

  editUser(user) {
    //user = this.userProvider.getUser(user.key);
    this.navCtrl.push('UserInfoPage', { mode: 'edit', user: user });
  }
  
  infoUser(user) {
    //user = this.userProvider.getUser(user.key);
    this.navCtrl.push('UserInfoPage', { mode: 'info', user: user });
  }

  searchCancel(ev: any) {
    this.users = this.userProvider.getUsers();
  }
  
  searchItems(ev: any) {
    this.users = this.userProvider.getUsersBySearch(ev.target.value, 'name')
  }

  editKey(user) {  
    let alert = this.alertCtrl.create({
      title: 'Cambiar clave de usuario',
      subTitle: 'La clave debe estar formada de 4 dígitos.',
      inputs: [
        {
          name: 'key',
          placeholder: 'Clave',
          type: 'password'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {}
        },
        {
          text: 'Cambiar',
          handler: data => {
            if(this.checkKey(data.key)) {
              this.codeProvider.isAvailable(data.key).then(result => {
                if(result) this.codeProvider.saveKey(user.key, data.key);
  
                else {
                  this.showMessage('Esta clave no está disponible')
                  return false;
                }
              })
            }

            else this.showMessage('La clave debe estar formada de 4 dígitos.');
          }
        }
      ]
    });
    alert.present();
  }

  private checkKey(key: string) {
    return String(+key) != 'NaN' && key.length == 4;
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/users/users.ts